import { FC, HTMLAttributes } from 'react'
import { useCustomRouter, useGetTranslations } from '@/root/shared-hooks'
import { formatDateTime } from '@/root/modules/shared/SelectTicketPage'
import { LockIconGray } from '@/root/ui/shared'

interface DepartureCardProps extends HTMLAttributes<HTMLDivElement> {
  timestamp: string
  isNextDay?: boolean // TODO: Check layout for next day
}

export const DepartureCard: FC<DepartureCardProps> = ({ timestamp }) => {
  const { locale } = useCustomRouter()
  const { getTranslation } = useGetTranslations()

  const { date, time } = formatDateTime({ dateTimeISO: timestamp, locale, warning: getTranslation('invalidDate') })

  return (
    <div
      data-testid="date-time-locked"
      className="border-base-normal-lighter bg-neutral-lightest text-base-normal-light xxs:text-large flex min-h-[104px] w-full cursor-not-allowed flex-col justify-between rounded-xl border p-4 text-xl leading-6 font-bold uppercase"
    >
      <div className="flex items-center justify-between">
        <p>{date}</p>
        <LockIconGray className="shrink-0" />
      </div>
      <p>{time}</p>
    </div>
  )
}
